import Swiper from 'swiper';
import SwiperCore, {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Controller,
  Thumbs,
  A11y,
} from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, A11y]);

export const createSwiper = (el, config) => {
  if (!config.lazy) return new Swiper(el, config);

  const { lazy, ...swiperConfig } = config;
  const rootMargin = typeof lazy === 'string' ? lazy : '200px';
  const target = typeof el === 'string' ? document.querySelector(el) : el;
  if (!target) return null;

  let instance = null;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          instance = new Swiper(target, swiperConfig);
          observer.disconnect();
        }
      });
    },
    { rootMargin }
  );
  observer.observe(target);

  return {
    get swiper() { return instance; },
    observer,
    destroy(deleteInstance, cleanStyles) {
      observer.disconnect();
      if (instance) instance.destroy(deleteInstance, cleanStyles);
      instance = null;
    },
  };
};

function loadImages(el) {
  const images = el.querySelectorAll('.image, .image-svg__elem');
  images.forEach((img) => {
    const lazyImages = (window.lazyImages = window.lazyImages || []);
    if (img && window.lazyImageFn) window.lazyImageFn(img);
    else if (img) lazyImages.push(img);
  });
}

export default () => {
  const swipers = document.querySelectorAll('.swiper__carousel');

  const carouselFn = (el, cconfig) => {
    const { config } = el.dataset;
    const _config = cconfig || window[config];
    if (!_config) return;

    const swiper = new Swiper(el, _config);
    _config.$swiper = swiper;
    loadImages(el);
  };

  swipers.forEach((el) => carouselFn(el));
  window.carouselFn = carouselFn;
};